import React from 'react';

const NewEditIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Edit-2">
        <g id="pencil">
          <path
            d="M13.7072 4.15079L12.1212 2.56476C11.9337 2.37729 11.6794 2.27197 11.4143 2.27197C11.1491 2.27197 10.8948 2.37729 10.7073 2.56476L9.35429 3.91779L12.3542 6.91783L13.7072 5.56481C13.8947 5.37728 14 5.12297 14 4.8578C14 4.59263 13.8947 4.33832 13.7072 4.15079Z"
            fill="#D18D02"
          />
          <path
            d="M8.6459 4.62581L2.99998 10.2719L2 14.272L5.99994 13.272L11.6459 7.62586L8.6459 4.62581Z"
            fill="#D18D02"
          />
        </g>
      </g>
    </svg>
  );
};

export default NewEditIcon;
